import {
  Flex,
  formatNumber,
  CurrencyValue,
  LineChart,
  ChartSkeleton
} from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import { useApi } from '@/api';
import type {
  SimpleChartData,
  SimpleChartDataset
} from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { ChartTimeFilter } from '@/components';
import { useParams } from 'react-router';
import { useChartPrefillDatasetsDates, useChartPeriod } from '@/hooks';

export default function HistoricGraphs() {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const { marketAddress } = useParams();
  const [data, error] = useApi<SimpleChartData[]>({
    url: `/markets/${marketAddress}/wallets/wallets-historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();

  const yScaleValueFormatter = (value: string | number) =>
    `${formatNumber(Number(value))}`;

  const valueFormatter = (value: string | number) => (
    <CurrencyValue
      value={value}
      variant="dynamic"
      options={{ notation: 'standard' }}
    />
  );

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const datasets: SimpleChartDataset[] = [
    {
      xField: 'date',
      yField: 'num_of_suppliers'
    }
  ];
  const chartData = useChartPrefillDatasetsDates(data, datasets);

  if (error) {
    throw error;
  }

  if (!data) {
    return <ChartSkeleton />;
  }
  return (
    <Flex flexDirection="column" gap="xs">
      <LineChart
        key="suppliers"
        data={chartData}
        datasets={datasets}
        config={config}
        valueFormatter={valueFormatter}
        yScaleValueFormatter={yScaleValueFormatter}
        timeFilter={timeFilter}
      />
    </Flex>
  );
}
